export const strings = {
    baseUrl: `https://web-service.nashresra.com/api/v1/`,
    baseUrl2: `https://web-service.nashresra.com/api/v2/`,
    version: '0.22',
    yourData: {
        alborz: 'البرز',
        ardebil: 'اردبیل',
        azerbaijansharghi: 'تبریز',
        azerbaijangharbi: 'ارومیه',
        bushehr: 'بوشهر',
        chvab: 'چهارمحال و بختیاری',
        fars: 'فارس',
        gilan: 'گیلان',
        golestan: 'گلستان',
        hamedan: 'همدان',
        hormozgan: 'هرمزگان',
        ilam: 'ایلام',
        esfehan: 'اصفهان',
        kerman: 'کرمان',
        kermanshah: 'کرمانشاه',
        khorasanshomali: 'خراسان شمالی',
        khorasanrazavi: 'خراسان رضوی',
        khorasanjunubi: 'خراسان جنوبی',
        khuzestan: 'خوزستان',
        kvab: 'کهکیلویه و بویراحمد',
        kordestan: 'کردستان',
        lorestan: 'لرستان',
        markazi: 'مرکزی',
        mazandaran: 'مازندران',
        ghazvin: 'قزوین',
        ghom: 'قم',
        semnan: 'سمنان',
        svab: 'سیستان و بلوچستان',
        tehran: 'تهران',
        yazd: 'یزد',
        zanjan: 'زنجان',
        khazar: 'دریای خزر',
        khalijefars: 'خلیج فارس',
        khark: 'خارک',
        kish: 'کیش',
        hormoz: 'هرمز',
        gheshm: 'قشم',
        lark: 'لارک',
        lavan: 'لاوان',
        faror: 'فارور',
        hendorabi: 'هندورابی',
        hengam: 'هنگام',
        siri: 'سیری',
        abumusa: 'ابوموسی',
        tonbebozorg: 'تنب بزرگ',
        tonbekuchak: 'تنب کوچک'
    },
    breadcrumbNameMap: [
        {
            link: '/dashboard',
            title: 'داشبورد',
        },
        // {
        //     link: '/sale',
        //     title: 'مدیریت فروش',
        //     children: [
        //         {
        //             link: '/sale/create',
        //             title: 'ایجاد مدیر'
        //         },
        //         {
        //             link: '/sale/edit',
        //             title: 'ویرایش مدیر'
        //         }
        //     ]
        // },
        {
            link: '/products',
            title: 'محصولات'
        },
        {
            link: '/productTypes',
            title: 'نوع محصول'
        },
        {
            link: '/categories',
            title: 'دسته بندی محصول'
        },
        {
            link: '/sliders',
            title: 'لیست اسلایدر'
        },
        {
            link: '/attributes',
            title: 'ایجاد ویژگی'
        },
        {
            link: '/tags',
            title: 'لیست برچسب ها'
        },

        {
            link: '/agencies',
            title: 'نمایندگی'
        },
        {
            link: '/blogs',
            title: 'پست های وبلاگ'
        },

        {
            link: '/orders',
            title: 'لیست سفارشات'
        },
        {
            link: '/reportOrders',
            title: 'گزارش سفارشات'
        },
        {
            link: '/users',
            title: 'لیست کاربران'
        },
        {
            link: '/adminUsers',
            title: 'لیست مدیران'
        },
        {
            link: '/message',
            title: 'ارسال پیام'
        },
        {
            link: '/reporting',
            title: 'گزارش گیری'
        },
        {
            link: '/notices',
            title: 'اطلاع رسانی'
        },
        {
            link: '/discount-codes',
            title: 'کد تخفیف'
        },
    ],
    messages:[
        {
            id: 1,
            text: "یک",
        },
        {
            id: 2,
            text: "دو",
        },
        {
            id: 3,
            text: "سه",
        },
        {
            id: 4,
            text: "چهار",
        },
        {
            id: 5,
            text: "پنج",
        },
        {
            id: 6,
            text: "شش",
        }
    ]
}
